import { app } from '../../../app';

app.component('userShared', {
    templateUrl: require('./users-shared.html'),
});


// WEBPACK FOOTER //
// ./src/portal/states/user/users-shared-accounts/users-shared.component.js